/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { getProductPageUrlSync } from '@msdyn365-commerce-modules/retail-actions';
import { ICartIconViewProps } from './c-cart-icon';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { logDetails } from '../../utils/debug-mode';
// import { IFlyoutCartLineItemViewProps } from './components/flyout-cart-line-items';

// const _renderCartlines = (cartLines: IFlyoutCartLineItemViewProps[] | undefined, props: ICartIconViewProps): JSX.Element[] | null => {
//     if (!cartLines) {
//         props.context.telemetry.error('Cartlines content is empty, module wont render');
//         return null;
//     }
//     return cartLines.map((cartLine, index) => {
//         return (
//             <Node {...props.miniCartItemWrapper} key={index}>
//                 {cartLine.cartline}
//                 {cartLine.storeLocation}
//                 {cartLine.remove}
//             </Node>
//         );
//     });
// };

const CartIconView: React.FC<ICartIconViewProps> = (props: ICartIconViewProps) => {
    const context = props.context.actionContext;
    const {
        config,
        resources,
        data: { cart },
        cartlines
    } = props;
    logDetails(props.context.app.config.debugMode, props);

    const getProductPageUrl = (name: string | undefined, recordId: string | number | undefined) => {
        return getProductPageUrlSync(name as string, recordId as number, context);
    };

    const getPrice = (price: number | undefined) => {
        if (typeof price !== 'undefined') {
            return props.context.cultureFormatter.formatCurrency(price);
        } else {
            return '';
        }
    };

    const handleIncreaseQuantity = (cartLineId: string | undefined, currentQuantity: number | undefined) => {
        if (!cartLineId || !currentQuantity) {
            return;
        }
        cart.result?.updateCartLines({
            updatedCartLinesObject: [
                {
                    LineId: cartLineId,
                    Quantity: currentQuantity + 1
                }
            ]
        });
    };

    const handleDecreaseQuantity = (cartLineId: string | undefined, currentQuantity: number | undefined) => {
        if (!cartLineId || !currentQuantity) {
            return;
        }
        if (currentQuantity === 1) {
            return;
        }
        cart.result?.updateCartLines({
            updatedCartLinesObject: [
                {
                    LineId: cartLineId,
                    Quantity: currentQuantity - 1
                }
            ]
        });
    };

    const handleRemoveCartLine = (cartLineId: string | undefined) => {
        if (!cartLineId) {
            return;
        }
        cart.result?.removeCartLines({
            cartLineIds: [cartLineId]
        });
    };

    const getProduct = (productId: number | undefined): SimpleProduct => {
        let simpleProduct: SimpleProduct = {} as SimpleProduct;
        if (cartlines && cartlines.length > 0) {
            cartlines.map(product => {
                if (product.data.product.RecordId === productId) {
                    simpleProduct = product.data.product;
                }
            });
        }

        return simpleProduct;
    };

    return (
        // <Node {...props.miniCartWrapper} {...props.renderModuleAttributes(props)}>
        //     {props.cartIcon}
        //     {props.FlyoutContainer ? (
        //         <Node {...props.FlyoutContainer}>
        //             {props.flyoutTitle}
        //             {props.checkoutBlockedDueToUnavailableFunds}
        //             <Node {...props.CartlinesWrapper}>{_renderCartlines(props.cartlines, props)}</Node>
        //             {props.totalPrice}
        //             {props.checkoutAsSignInUserButton}
        //             {props.checkoutAsGuestButton}
        //             {props.goToCartButton}
        //         </Node>
        //     ) : (
        //         false
        //     )}
        // </Node>
        <Node {...props.miniCartWrapper} {...props.renderModuleAttributes(props)}>
            <div className='Header-Button Header-Button_type_minicart'>
                <button tabIndex={0} title='My Basket' className='Header-MinicartButtonWrapper'>
                    <span aria-label='Items in cart' className='Header-MinicartItemCount'>
                        {props.data.cart.result?.totalItemsInCart || 0}
                    </span>
                </button>
                {props.FlyoutContainer ? (
                    <Node {...props.FlyoutContainer}>
                        <Node {...props.FlyoutContainer}>
                            <div className='ml-c-cart-dropdown-Modal Overlay CartOverlay Overlay_isVisible  CartOverlay_isVisible'>
                                <div className='CmsBlock-Wrapper CmsBlock-Wrapper_type_'>
                                    <div data-content-type='row' data-appearance='contained' data-element='main'>
                                        <div>
                                            <h3>{props.flyoutTitle}</h3>
                                            <p>
                                                <Msdyn365.RichTextComponent text={config.freeDeliveryText} />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='MiniCart-Items'>
                                    {props.data.cart.result?.cart.CartLines &&
                                        props.data.cart.result?.cart.CartLines.length > 0 &&
                                        props.data.cart.result?.cart.CartLines.map(cartLine => {
                                            return (
                                                <div key={cartLine.LineId} aria-label='List of items in cart' className='CartOverlay-Items'>
                                                    <div className='CartItem CartItem_isEditing'>
                                                        <a
                                                            href={getProductPageUrl(
                                                                getProduct(cartLine.ProductId).Name,
                                                                cartLine.ProductId
                                                            )}
                                                            className=' CartItem-Link'
                                                        >
                                                            <figure className='CartItem-Wrapper'>
                                                                <div className='Image Image_ratio_custom Image_imageStatus_1 Image_hasSrc CartItem-Picture '>
                                                                    <img
                                                                        src={
                                                                            (cartLine.ExtensionProperties?.find(
                                                                                prop => prop.Key === 'INSCONFIGURATIONIIMAGE'
                                                                            )?.Value?.StringValue as string) ||
                                                                            getProduct(cartLine.ProductId).PrimaryImageUrl
                                                                        }
                                                                        alt={getProduct(cartLine.ProductId).PrimaryImageUrl}
                                                                        className='Image-Image'
                                                                        style={{ width: '100%', height: '100%' }}
                                                                    />
                                                                </div>
                                                                <img
                                                                    src={
                                                                        (cartLine.ExtensionProperties?.find(
                                                                            prop => prop.Key === 'INSCONFIGURATIONIIMAGE'
                                                                        )?.Value?.StringValue as string) ||
                                                                        getProduct(cartLine.ProductId).PrimaryImageUrl
                                                                    }
                                                                    alt={getProduct(cartLine.ProductId).PrimaryImageUrl}
                                                                    style={{ display: 'none' }}
                                                                />
                                                                <figcaption className='CartItem-Content CartItem-Content_isLikeTable_undefined'>
                                                                    <div className='CartItem-HeadingWrapper'>
                                                                        <p className='CartItem-Heading'>
                                                                            {getProduct(cartLine.ProductId).Name}
                                                                        </p>
                                                                    </div>
                                                                    {/* <div className='CartItem-QtyRestrictions' />
                                                    <ul className='CartItem-Options CartItem-Options_isLikeTable_undefined'>
                                                        <li aria-label='pack_size' className='CartItem-Option'>
                                                            1
                                                        </li>
                                                        <li aria-label='material' className='CartItem-Option'>
                                                            3mm Plywood
                                                        </li>
                                                        <li aria-label='sides' className='CartItem-Option'>
                                                            Single Sided
                                                        </li>
                                                        <li aria-label='texture' className='CartItem-Option'>
                                                            ST36 Feelwood Brushed
                                                        </li>
                                                        <li aria-label='size_code' className='CartItem-Option'>
                                                            2440x1220x2.7mm
                                                        </li>
                                                    </ul> */}
                                                                    <p
                                                                        aria-label='Product Price'
                                                                        className='ProductPrice CartItem-Price CartItem-Price_isLikeTable_undefined'
                                                                    >
                                                                        <span aria-label='Current product price'>
                                                                            <data value={getPrice(cartLine.Price)}>
                                                                                {getPrice(cartLine.Price)}
                                                                            </data>
                                                                        </span>
                                                                    </p>
                                                                </figcaption>
                                                            </figure>
                                                        </a>
                                                        <div className='CartItem-Actions CartItem-Actions_isEditing CartItem-Actions_isLikeTable_undefined'>
                                                            <button
                                                                id='RemoveItem'
                                                                name='RemoveItem'
                                                                aria-label='Remove item from cart'
                                                                className='CartItem-Delete'
                                                                onClick={() => handleRemoveCartLine(cartLine.LineId)}
                                                            >
                                                                <span className='CartItem-DeleteButtonText'>Delete</span>
                                                            </button>
                                                            <div className='CartItem-QuantityWrapper'>
                                                                <span className='CartItem-QuantityText'>Qty:</span>
                                                                <div className='Field Field_type_number Field_isValid Field_id_item_qty CartItem-Qty'>
                                                                    <input
                                                                        id='item_qty'
                                                                        name='item_qty'
                                                                        type='number'
                                                                        readOnly={true}
                                                                        className='CartItem-Qty'
                                                                        value={cartLine.Quantity?.toString() || '1'}
                                                                    />
                                                                    <button
                                                                        aria-label='Add'
                                                                        onClick={() =>
                                                                            handleIncreaseQuantity(cartLine.LineId, cartLine.Quantity)
                                                                        }
                                                                    />
                                                                    <button
                                                                        aria-label='Subtract'
                                                                        onClick={() =>
                                                                            handleDecreaseQuantity(cartLine.LineId, cartLine.Quantity)
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>

                                <div className='CartOverlay-Additional'>
                                    {props.cartlines?.length ? (
                                        <>
                                            <dl className='CartOverlay-Discount'>
                                                <dt>{resources.miniCartSubTotalLabel}:</dt>
                                                <dd>{getPrice(props.data.cart.result?.cart.NetPrice)}</dd>
                                            </dl>
                                            <dl className='CartOverlay-Discount'>
                                                <dt>{resources.miniCartDiscountLabel}:</dt>
                                                <dd>-{getPrice(props.data.cart.result?.cart.DiscountAmount)}</dd>
                                            </dl>
                                            <dl className='CartOverlay-Total'>
                                                <dt>{resources.miniCartTotalLabel}:</dt>
                                                <dd>{props.totalPrice}</dd>
                                            </dl>
                                        </>
                                    ) : null}
                                    <div className='SavedAmount-CartOverlay' />
                                    <div className='CartOverlay-Actions'>
                                        <a
                                            href={props.app.routes.cart.destinationUrl}
                                            className={`${
                                                props.cartlines?.length ? '' : 'MiniCart_Button'
                                            } CartOverlay-CartButton Button Button_isHollow`}
                                        >
                                            {resources.miniCartTitle} ({props.data.cart.result?.totalItemsInCart || 0})
                                        </a>
                                        {props.cartlines?.length ? (
                                            <a
                                                href={
                                                    !props.context.request.user.isAuthenticated
                                                        ? props.context.request.user.signInUrl
                                                        : props.app.routes.checkout.destinationUrl
                                                }
                                                className='CartOverlay-CheckoutButton Button'
                                            >
                                                <span />
                                                {resources.checkoutButtonTitle}
                                            </a>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </Node>
                    </Node>
                ) : null}
            </div>
        </Node>
    );
};

export default CartIconView;
